import React from 'react';
import { useAuth } from 'contexts/AuthContext';
import { PageContainer, PageHeader, Breadcrumb, PageTitle, Card } from 'styles/common.styles';

const HrDashboard = () => {
  const { user, compCd } = useAuth();

  return (
    <PageContainer>
      <PageHeader>
        <Breadcrumb>
          <span>홈</span>
          <span className="separator">›</span>
          <span className="current">대시보드</span>
        </Breadcrumb>
        <PageTitle>인사관리 대시보드</PageTitle>
      </PageHeader>
      <Card style={{ padding: 24, lineHeight: 1.7 }}>
        <p><strong>로그인 사용자</strong>: {user?.name || user?.username} ({user?.id})</p>
        <p><strong>기관코드</strong>: {compCd || user?.compCd}</p>
        <hr style={{ margin: '16px 0' }} />
        <p><strong>PoC 메뉴</strong></p>
        <ul>
          <li>발령 목록 — 기준일(asOfDate) 유효 발령 조회</li>
          <li>인사카드 — 준비 중</li>
          <li>부서관리 — 상위부서·예산역할(편성/집행) · 조직변경 이력</li>
        </ul>
      </Card>
    </PageContainer>
  );
};

export default HrDashboard;
